import { gql } from '@apollo/client/core';

export const CRM_STAGE_FIELDS = gql`
  fragment CrmStageFields on CrmStageProjection {
    connectionId
    providerId
    providerLabel
    stageId
    stageLabel
    providerObservedAt
    state
    lastSuccessStatus
    lastAttemptAt
    lastSuccessAt
  }
`;
